export {
  default as brush,
  brushX,
  brushY,
  brushSelection
} from "./src/brush";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-brush/index.js
// module id = ../../../../d3-brush/index.js
// module chunks = 4